import React from 'react';
import SearchBlock from './SearchBlock';
import './index.scss';

const FilterBlock = ({_change, _keyword}) => {
	return (
		<div className="payment-filter-blc d-flex align-items-center">
			<SearchBlock  _change={_change} _keyword={_keyword}/>
		</div>
	);
}

export default FilterBlock; 